import { forwardRef } from 'react';
import { classNames } from '../../utils/classNames';
import FormField from './FormField';

const Textarea = forwardRef(function Textarea(
  { id, label, hint, error, required, className, rows = 4, ...props },
  ref
) {
  return (
    <FormField id={id} label={label} hint={hint} error={error} required={required} className={className}>
      <textarea
        ref={ref}
        id={id}
        rows={rows}
        required={required}
        aria-invalid={Boolean(error)}
        aria-describedby={hint || error ? `${id}-description` : undefined}
        className={classNames('w-full resize-y rounded-control border bg-white px-3 py-2.5 text-sm text-content-primary shadow-xs outline-none transition placeholder:text-slate-400 focus:border-primary-500 focus:shadow-focus disabled:bg-slate-100', error && 'border-danger-500')}
        {...props}
      />
    </FormField>
  );
});

export default Textarea;
